<cc-top-bar [title]="'DEVELOPERS.LABEL'">
</cc-top-bar>

<div class="box-wrapper">
  <cc-box>
    <div class="container-responsive" content box>

      <img src="/assets/img/channels/logo-apikey.svg" alt="">
      <div class="api-description">
        <span translate="DEVELOPERS.API_INFO"></span>
        <a href="https://developers.channels.app"
           target="_blank"
           class="text-info"
           translate="DEVELOPERS.READ_MORE">
        </a>
      </div>

      <div class="api-key-row bottom-border">
        <span class="api-key-label" translate="ACCOUNT"></span>
        <span>{{getAccount()}}</span>
      </div>
      <div class="api-key-row">
        <span class="api-key-label" translate="DEVELOPERS.API_KEY"></span>
        <span *ngIf="apiKey">{{apiKey}}</span>
        <button *ngIf="apiKey"
                class="btn primary"
                (click)="revoke()"
                translate="REVOKE"></button>
        <button *ngIf="!apiKey"
                class="btn primary"
                (click)="generate()"
                translate="GENERATE"></button>
      </div>

    </div>
  </cc-box>
</div>
